/* eslint-disable */
import React from "react";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles(() => ({
  icon: {
    float: "left",
    margin: "0 20px 20px 0",
    height: "100%",
    fill: "white",
  },
  createButton: {
    backgroundColor: '#1A9FE0',
    width: 140,
    fontWeight: 800,
    textTransform: 'inherit',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#FFFFFF',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 8
  },
  closeButton: {
    backgroundColor: '#EAEAEA',
    width: 140,
    fontWeight: 800,
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#666666',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 24
  }
}));

export default function ConfirmSapIdDialog(props: any) {
  const classes = useStyles();

  return (
    <div className="float-left">
      <Dialog
        open={props.open ? true : false}
        onClose={() => { props.handleopenClose(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth={true}>

        <DialogContent>
          <div className="d-flex justify-content-center">
            <CheckCircleIcon className="quotation-created" fontSize="small" />
          </div>
          <div className="d-flex justify-content-center">
            <DialogContentText id="alert-dialog-description">
              <div className="mt-2">
                <h5 className="submit-dialog-content">Customer SAP ID Successfully Created</h5>
                <p className="d-flex justify-content-center">ID: {props.sapId}</p>
              </div>
              <div className="pr-2 pl-0">
                <p className="pt-3 pb-2">Please provide transportation zones for rest of the ship to party addresses.</p>
              </div>
            </DialogContentText>
          </div>
        </DialogContent>
        <DialogActions className="mb-3 justify-content-center">
          <Button variant="contained"
            size="large"
            color="secondary" className={`createFavourite ${classes.createButton}`}
            onClick={() => {
              props.handleopenClose('Submit')
            }}>Ship to party
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}
